import MatchMedia from '../utils/matchMedia';

export default class DialogPopin {
    constructor() {
        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            myDialogBtn: document.querySelectorAll(".js-modal-button"),
            myDialogClose: document.querySelectorAll("#dialog__layer .btn-close")
        }
    }

    listen() {
        if(this.ui.myDialogBtn.length > 0) { // Si au moins un bouton modale se trouve dans la page
            this.ui.myDialogBtn.forEach((item) => { // Pour chaque bouton d'ouverture de modale
                item.addEventListener("click",() => { // Ouverture modale
                    const itemId = item.getAttribute("id");
                    const itemTarget = item.getAttribute("data-target");
                    openDialog(itemTarget, itemId);
                });
            });
            this.ui.myDialogClose.forEach((item) => { // Pour chaque bouton de fermeture de modale
                item.addEventListener("click",() => { // Fermeture modale
                    closeDialog(item);
                });
            });
        }
    }
}